import styled from "styled-components";
import {JBOptinReminderCheckboxDefaultBox} from "./jb-optin-reminder-checkbox.default.box";

export const JBOptinReminderCheckbox777Box = styled(JBOptinReminderCheckboxDefaultBox)`
    border-color: ${props => props.theme.colors.brandSecondaryContrast};
`;